import React from 'react';

import AwardedLegacy from './productsPartials/AwardedLegacy';
import AwardedIcons from './productsPartials/AwardedIcons';

const Awarded = () => {
  return (
    <div className="awarded">
      <div className="container">
        <AwardedLegacy />
        <AwardedIcons />
      </div>
    </div>
  );
};

export default Awarded;
